import { render, staticRenderFns } from "./StatisticsExtraChart.vue?vue&type=template&id=931d27a2&scoped=true"
import script from "./StatisticsExtraChart.vue?vue&type=script&lang=js"
export * from "./StatisticsExtraChart.vue?vue&type=script&lang=js"
import style0 from "./StatisticsExtraChart.vue?vue&type=style&index=0&id=931d27a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931d27a2",
  null
  
)

export default component.exports